export default __webpack_public_path__ + "static/media/422-Series-Stainless-Regulators.743d8767.jpg";